export const contingentArrowUpIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 13 6"><path d="M12 5L6.5 1 1 5" stroke="#1A80BA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'arrow-up',
};
